import type { PriceAdjustmentRule } from '@einhaus/project314-types';

export type TradingProfilePathRecord = { [key: string]: TradingProfilePathValue };
export type TradingProfilePathValue = string | number | boolean | null | undefined | TradingProfilePathValue[] | TradingProfilePathRecord;

export const isTradingProfilePathRecord = (value: TradingProfilePathValue): value is TradingProfilePathRecord => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export type PriceAdjustmentRulePriceReference = NonNullable<PriceAdjustmentRule['priceReference']>;
export type PriceAdjustmentRuleAdjustmentUnit = NonNullable<PriceAdjustmentRule['adjustmentUnit']>;

export const isPriceAdjustmentRuleTradeType = (value: string): value is PriceAdjustmentRule['tradeType'] => {
    return value === 'buy' || value === 'sell';
};

export const isPriceAdjustmentRuleDirection = (value: string): value is PriceAdjustmentRule['direction'] => {
    return value === 'up' || value === 'down';
};

export const isPriceAdjustmentRulePriceReference = (value: string): value is PriceAdjustmentRulePriceReference => {
    return value === 'currentLimit' || value === 'bid' || value === 'ask' || value === 'askBidMid';
};

export const isPriceAdjustmentRuleAdjustmentUnit = (value: string): value is PriceAdjustmentRuleAdjustmentUnit => {
    return value === 'percentage' || value === 'ticks';
};
